import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "container d-flex flex-column text-center",
  style: {"gap":"3"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { style: {"font-size":"10vw","user-select":"none","font-weight":"bold","cursor":"pointer"} }, [
  /*#__PURE__*/_createElementVNode("text", { style: {"white-space":"nowrap"} }, "Hi Kayii!"),
  /*#__PURE__*/_createElementVNode("text", null, "😄")
], -1)
const _hoisted_3 = { style: {"font-size":"5vw","font-weight":"semi-bold","text-align":"center"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { style: {"font-size":"3vw","text-align":"center"} }
const _hoisted_7 = ["innerHTML"]

import { Message, messageConverter } from "@/models/Message";
import {
  getFirestore,
  query,
  collection,
  onSnapshot,
} from "@firebase/firestore";
import { onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let messages = ref<Array<Message>>(Array<Message>());
let selected = ref<Message>();

onMounted(() => {
  const db = getFirestore();
  const q = query(collection(db, "messages")).withConverter(messageConverter);
  const unsubscribe = onSnapshot(q, (querySnapshot) => {
    messages.value = Array<Message>();
    querySnapshot.forEach((doc) => {
      const message = doc.data();
      if (message.isActive) messages.value.push(message);
    });
    onClick();
  });
});

function onClick() {
  if (messages.value.length > 0) {
    let index = Math.floor(Math.random() * messages.value.length);
    selected.value = messages.value[index];
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "home",
    class: "w-100 h-100 d-flex justify-content-center",
    onClick: _cache[0] || (_cache[0] = () => onClick()),
    style: {"margin-top":"60px","margin-bottom":"60px"}
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock("div", {
            key: _unref(selected)?.id,
            style: {"user-select":"none","cursor":"pointer"}
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("text", _hoisted_3, _toDisplayString(_unref(selected)?.header), 1),
              _hoisted_4,
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  innerHTML: _unref(selected)?.message
                }, null, 8, _hoisted_7)
              ])
            ])
          ]))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})